import { useMemo, useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import CustomCheckbox from '../../customCheckbox';
import UserAvatar from '../../userAvatar';
import { getItemById } from '../../../../utility/helpers';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  main: {
    borderBottom: `1px solid ${primary.bluish7}`,
    display: 'flex',
    alignItems: 'center',
    padding: spacing(4, 0),
    width: '100%',
  },
  userAvatar: {
    width: 'fit-content',
    maxWidth: 'calc(100% - 142px)',
  },
  status: {
    display: 'flex',
    marginLeft: 'auto',
    width: 94,
  },
  checkbox: {
    marginRight: spacing(2),
  },
  icon: {
    marginRight: spacing(2),
  },
}));

const Reviewer = ({
  reviewer,
  isSelected,
  isClickable,
  completionStatuses,
  isDisabled,
  isSelectable,
  onGoToPersonProfile,
  onChange,
}) => {
  const classes = useStyles();

  const { icon: Icon, name } = useMemo(
    () => getItemById(completionStatuses, reviewer.completion_status),
    [reviewer.completion_status, completionStatuses]
  );

  const handleGoToProfilePage = useCallback(
    () => onGoToPersonProfile(reviewer.id),
    [reviewer.id, onGoToPersonProfile]
  );

  const hadleCheckboxChange = useCallback(
    isChecked => onChange(isChecked, reviewer),
    [reviewer, onChange]
  );

  return (
    <div className={classes.main}>
      {isSelectable && (
        <CustomCheckbox
          className={classes.checkbox}
          isChecked={isSelected}
          onChange={hadleCheckboxChange}
          disabled={isDisabled}
          isControlled
        />
      )}
      <UserAvatar
        className={classes.userAvatar}
        variant="subtitle2"
        user={reviewer}
        clickableCaption={isClickable}
        onClickHandler={handleGoToProfilePage}
        small
        caption
      />
      <div className={classes.status}>
        <Icon className={classes.icon} />
        <Typography variant="body2">{name}</Typography>
      </div>
    </div>
  );
};

Reviewer.propTypes = {
  reviewer: PropTypes.shape({}).isRequired,
  isClickable: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isSelectable: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onGoToPersonProfile: PropTypes.func.isRequired,
};
export default memo(Reviewer);
